<template>
    <v-dialog max-width="80%" v-model="dialog">
        <template v-slot:activator={on}>
            <v-btn text v-on=on>
                <v-icon left>mdi-plus</v-icon>Add Supplier
            </v-btn>
        </template>
        <v-card :loading="loading">
            <v-card-title>Add Supplier</v-card-title>
            <v-card-text>
                <v-alert v-if="errors.length > 0" type="error">
                    <p v-for="(error,idx) in errors" :key="'_err_'+idx">{{error}}</p>
                </v-alert>
                <v-form ref="addForm">
                    <v-checkbox v-model="model.isEnabled" label="Is Enabled ?" />
                    <v-text-field v-model="model.name" label="Name" :rules="[rules.required]"/>
                    <v-textarea v-model="model.description" label="Description" />
                    <v-text-field v-model="model.contact" label="Contact" />
                    <v-text-field v-model="model.contact_mail" label="Contact Mail" />
                    <v-text-field v-model="model.account_number" label="Account Number" />
                    <v-radio-group v-model="model.lang">
                        <v-radio label="English" value="en" />
                        <v-radio label="French" value="fr" />
                    </v-radio-group>
                    <v-textarea v-model="model.other" label="Other" />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="dialog=false">Cancel</v-btn>
                <v-spacer />
                <v-btn @click="save" color="primary">Add</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    data: () => ({
        dialog:null,
        model:{
            isEnabled:false,
            name:'',
            description:'',
            contact:'',
            account_number:'',
            other:'',
        },
        rules: {
            required: value => !!value || "This field is mandatory.",
        },
        loading:false,
        errors:[]
    }),
    methods:{
        ...mapActions("supplier", ["create"]),
        save(){
            this.errors=[]
            if (this.$refs.addForm.validate()) {
                this.loading=true
                this.create(this.model)
                .then(() => {
                    this.$emit("added")
                    this.dialog=false
                    this.model = {isEnabled:false, name:'', description:'', contact:'',account_number:'', other:''}
                })
                .catch(({data}) => {
                    for (const error of Object.entries(data.errors)) {
                        this.errors.push(error[1][0])
                    }
                })
                .finally(() => {
                    this.loading=false
                })
            }
        }
    }
}
</script>

<style>

</style>